import React from "react";
import { useRoutes } from "react-router-dom";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import protectedRoutes from "./protected";
import membersRoutes from "./members";
import courierRoutes from "./courier";
import publicRoutes from "./public";
import shopRoutes from "./shop";
import Header from "../components/Header/auth-header";
import Sidebar from "../components/Sidebar";
import { Layout } from "antd";
const { Sider } = Layout;

function AppRoutes() {
  // Sidebar
  let roldeId = localStorage.getItem("items");
  var bytes = CryptoJS.AES.decrypt(
    roldeId || 1,
    "J8Lw2Be[CdBZhf/!3?}973Z5O'uNtY4N"
  );
  var originalText = bytes.toString(CryptoJS.enc.Utf8);
  var routerPath;

  // Define Router based on roles
  switch (originalText) {
    case "1":
      routerPath = protectedRoutes;
      break;
    case "2":
      routerPath = shopRoutes;
      break;
    case "3":
      routerPath = membersRoutes;
      break;
    case "4":
      routerPath = shopRoutes;
      break;
    case "5":
      routerPath = courierRoutes;
      break;
  }

  const auth = Cookies.get("auth-token") ? "Yes" : "No";
  const routes = auth === "Yes" ? routerPath : publicRoutes;
  const element = useRoutes([...routes]);

  if (auth === "Yes" && (originalText === "1" || originalText === "3")) {
    return (
      <Layout>
        <Header />
        <Layout hasSider>
          <Sider>
            <Sidebar roldeId={originalText} />
          </Sider>
          <div className="main-body">{element}</div>
        </Layout>
      </Layout>
    );
  } else if (auth === "Yes") {
    return (
      <Layout>
        <Header />
        <div className="main-body">{element}</div>={" "}
      </Layout>
    );
  }
  return <>{element}</>;
}

export default AppRoutes;
